
$(document).ready(function() { 
	var data=[
		{id: ' ', text:'请选择院校或组织，注册成功后不可修改'}
	];
	$.ajax({
		type: "post",
		url: "/register/medicalschool/list", 
		data:{},
		dataType : "json",
		async: false, 
		error: function(request) {
			console.log('出错啦！');
			console.log(request.responseJSON);
		},
		success: function(ret) {
			for(var i=0;i<ret.data.length;i++){
				var unit = {
					id: ret.data[i].id,
					text: ret.data[i].name
				}
				data.push(unit);
			}
		}
	});
	$("#subject-select").empty().select2({
		width: 450,//设置下拉框宽度
		minimumResultsForSearch: -1,
		data: data
	});  
	$("#subject-select").on("select2:open",function(e){ 
		$('.selection').find('.select2-selection').css('border','solid 1px #6296ea')
	}).on("select2:close",function(e){ 
		$('.selection').find('.select2-selection').css('border','1px solid #ccc')
	});
});

//错误信息显示
function errorNews(element, message ){
	$('#' + element +'').parents('.form-item').find('.errorr').html(message);
	$('#' + element +'').parents('.form-item').find('.item-input').addClass('error-border');
	if(element == 'subject-select'){
		$('.selection').find('.select2-selection').css('border','1px solid #d61616')
	}
} 

//错误信息隐藏
function errorNewsHide(){
	$('.form-item').find('.errorr').html(''); 
	$('.item-input').removeClass('error-border'); 
	$('.selection').find('.select2-selection').css('border','1px solid #ccc')
}
$("#subject-select").on('change',function (evt) {
	if(!$.trim($(this).val())){
		$("#medicalSchoolId").val('');
		return;
	}
	$("#medicalSchoolId").val($(this).val());
});

//注册账号表单验证    
$("#submit").click(function(){
	errorNewsHide();
	$(".error-blank").remove();
	var login = $.trim($("#login").val());
	if(!login){
		errorNews('login', '请输入用户名！' );
		return false;
	} 
	 
	if(!/^(?=.*[A-Za-z].*)[_0-9A-Za-z]{2,15}$/.test(login)){  // /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{2,15}$/
		errorNews('login', '用户名格式错误（字母加数字组成 长度2到15位）！' );
		return false;
	}	
	
	var unit =$.trim($("#medicalSchoolId").val());
	if(!unit){
		errorNews('subject-select', '请选择院校或组织，注册成功后不可修改！' );
		return false;
	}
	var password = $.trim($("#password").val());
	if(!password){
		errorNews('password', '请输入密码！' );
		return false;
	}	
	
	if(!/^[0-9A-Za-z]{6,20}$/.test(password)){
		errorNews('password', '密码格式错误（字母或数字组成 长度6到20位）！' ); 
		return false;
	}	
	
	var confirmPassword = $.trim($("#confirmPassword").val());
	if(confirmPassword !== password){
		errorNews('confirmPassword', '两次密码不一致！' ); 
		return false;
	}
	
	var mobileNo = $.trim($("#mobileNo").val());
	if(!mobileNo){
		errorNews('mobileNo', '请输入手机号！' );
		return false;
	}	
	
	if(!/^1[3|4|5|7|8|9][0-9]\d{8}$/.test(mobileNo)) {
		errorNews("mobileNo", '请输入正确的手机号！'); 
		return false;   
	} 
	
	var code = $.trim($("#code").val());
	if(!code){
		errorNews('code', '请输入短信验证码！' );
		return false;
	}	
	
	if($("#user").is(':checked')){
		$("#user").val('y');
	} else {
		$(".form-blank").prepend('<div class="error error-blank"></div>');
		errorNews('user', '请同意艾知星用户协议！' );
		return false;
	} 
	
	var formData = $("#loginForm").serialize()+'&medicalSchoolId='+$.trim($("#medicalSchoolId").val());
	$.ajax({
		type: "POST",
		url: '/register' + "?r="+Math.random(),
		data:formData,
	    dataType : "json",
	    async: false,
		error: function(request) { 
			console.log('出错啦！');
			console.log(request.responseJSON);
		},
		success: function(ret) {
			if(ret.code == 1){
				$("#loginForm").hide();
				$(".success").show();
				threeDown();
			} else{
				$(".loginError span").html(ret.message);
			}
		}
	});
});

//手机号change事件
$("#mobileNo").keyup(function(){ 
	errorNewsHide();
	var mobileNo = $.trim($(this).val());
	if(!/^1[3|4|5|7|8][0-9]\d{8}$/.test(mobileNo)) {
		$(".imgCodeBtn").attr("src", '/static/images/login/default.png');
		return false;   
	} else {
		obtainCode();
	}
});

$("#mobileNo").blur(function(){ 
	errorNewsHide();
	var mobileNo = $.trim($(this).val());
	if(mobileNo && !/^1[3|4|5|7|8][0-9]\d{8}$/.test(mobileNo)) {
		errorNews("mobileNo", '请输入正确的手机号！'); 
		return false;   
	}
});

//获取图片验证码
function obtainCode(){
	var mobileNo = $.trim($("#mobileNo").val());
	var url = '/verification-code/get?mobileNo=' + mobileNo + "&r="+Math.random()
	$(".imgCodeBtn").attr("src",url);
}

//换一张 
$("#imgCodeBtn").click(function(){
	errorNewsHide();
	var mobileNo = $.trim($("#mobileNo").val());
	if( !mobileNo) {
		errorNews("mobileNo", '请输入手机号！'); 
		return false;   
	}
	
	if(mobileNo && !/^1[3|4|5|7|8][0-9]\d{8}$/.test(mobileNo)) {
		errorNews("mobileNo", '请输入手机号！'); 
		return false;    
	}
	
	var url = '/verification-code/get?mobileNo=' + mobileNo + "&r="+Math.random()
	$(".imgCodeBtn").attr("src",url);
});

//倒计时
var countdown = 60; 
function settime(id) { 
	if (countdown == 0) { 
		id.attr("disabled",false);  
		id.val("获取验证码"); 
		id.addClass('code-btn');
		id.removeClass('code-countDown');
		countdown = 60; 
		$("#imgCodeBtn").click();
		$("#imgCode").val('');
		return;
	} else { 
		id.attr("disabled", true); 
		id.val("重新发送(" + countdown + ")"); 
		id.addClass('code-countDown');
		id.removeClass('code-btn');
		countdown--; 
	}; 
	setTimeout(function() { 
		settime(id);
		},1000); 
}

function countDown(id){
	countdown = 60; 
	settime(id);
}

var threeSeconds = 3; 

function threeTime() { 
	if (threeSeconds == 0) { 
		$(".success-explain span").html(threeSeconds); 
		window.location.href = '/security/useraccount/enter';
		return;
	} else { 
		$(".success-explain span").html(threeSeconds); 
		threeSeconds--; 
	}; 
	setTimeout(function() { 
		threeTime();
		},1000); 
}

function  threeDown(){
	threeSeconds = 3; 
	threeTime();
}

//获取短信验证码
$("#codeBtn").click(function(){
	errorNewsHide();
	var val = $.trim($(this).val());
	if(val != '获取验证码'){
		return false;   
	}
	
	var mobileNo = $.trim($("#mobileNo").val());
	var imgCode = $.trim($("#imgCode").val());
	if( !mobileNo) {
		errorNews("mobileNo", '请输入手机号！'); 
		return false;   
	}
	
	if(mobileNo && !/^1[3|4|5|7|8][0-9]\d{8}$/.test(mobileNo)) {
		errorNews("mobileNo", '请输入正确的手机号！'); 
		return false;   
	}
	
	if(!imgCode){
		errorNews("imgCode", '请输入图片验证码！'); 
		return false;
	}
	
	if(!/^[0-9A-Za-z]{4}$/.test(imgCode)){
		errorNews("imgCode", '请输入正确的图片验证码！'); 
		return false;
	}
	
	$.ajax({
		type: "POST",
		url: '/sms/send/code' + "?r="+Math.random(),
		data:{'mobileNo': mobileNo, 'imgCode': imgCode},
	    dataType : "json",
	    async: false,
		error: function(request) { 
			console.log('出错啦！');
			console.log(request.responseJSON);
		},
		success: function(ret) {
			if(ret.code != 1){
				if(ret.extData == 'imgCode'){
					errorNews("imgCode", ret.message); 
					obtainCode();
				}else if(ret.extData == 'mobileNo'){
					errorNews("mobileNo", ret.message); 
					obtainCode();
				} else {
					$('#codeBtn').parents('.form-item').find('.error').html(ret.message);
				}
			}
			
			if(ret.code == 1){
				countDown($("#codeBtn"));
			}
		}
	});
	
});

//input
$("input").focus(function(){
    $(this).parent().addClass("focus");
});
 
$("input").blur(function(){
    $(this).parent().removeClass("focus"); 
});